import React, { useEffect, useState } from "react";
import AppSettings from "../../../Settings/AppSettings";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import Utils from "../../../Common/Utils";
import { toast } from "react-toastify";
import OverlayIcon from "../Rules/Components/OverlayIcon";
import RefreshIcon from "../Builder/Components/RefreshIcon";
import ProductViewHeader from "./ProductView/ProductViewHeader";
import ProductViewSkeleton from "./ProductView/ProductViewSkeleton";
import Attributes from "./ProductView/Attributes";
import MoreDetails from "./ProductView/MoreDetails";
import AccordionBody from "Components/Common/components/Accordion/AccordionBody"
import AccordionHeader from "Components/Common/components/Accordion/AccordionHeader"
import AccordionLayout from "Components/Common/components/Accordion/AccordionLayout"
import DeltaTable from "Components/Common/DeltaTable"
import SkeletonElement from "../Category/Shimmer/SkeletonElement";


const ProductView = ({ productid }) => {
  
  const [productDetails, setProductDetails] = useState(null);
  const [productImage, setProductImage] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [showBuilder, setShowBuilder] = useState(false);
  const [compatibleProduct, setCompatibleProduct] = useState(null);
  const placeHolderImage = "https://cdn1.vectorstock.com/i/thumb-large/50/20/no-photo-or-blank-image-icon-loading-images-vector-37375020.jpg";
  const [loadCompatible, setLoadCompatible] = useState(true);

  const [Loading, setLoading] = useState({
    status: "",
    message: "",
  });

  let api_base_url = AppSettings.GMS_BACKEND_API_URL;

  async function load_Product_details_by_id() {
    setProductDetails(null);
    // setCompatibilityreloadCounter(0);

    setLoading({
      status: "Loading",
      message: "Loading Product Details",
    });

    let res = await ServiceWrapper.doGet(
      `${api_base_url}product/details/${productid} `,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      if (res.data.done === true) {
        if (res?.data?.data === null) {
          toast.error("Data error");
          setProductDetails(null);
          setShowBuilder(true);
          return;
        }
        setProductDetails(res.data.data);
        if (res?.data?.data?.product_image_detail !== "") {
          let final = JSON.parse(
            res.data.data.product_image_detail.replace(/'/g, '"')
          );
          if (
            final &&
            final.length > 0 &&
            final[0].JPEG_IMAGES &&
            final[0].JPEG_IMAGES.default_image
          ) {
            let images = [];
            images.push(final[0].JPEG_IMAGES.default_image);
            images = images.concat(final[0].JPEG_IMAGES.images);
            setProductImage(final[0].JPEG_IMAGES.default_image);
            setProductImages(images);
          }
        }
        setLoading({
          status: "Success",
          message: undefined,
        });
        setShowBuilder(true);
      } else {
        setLoading({
          status: "Error",
          message: res.data.message,
        });
        setShowBuilder(true);
      }
    } else {
      setShowBuilder(true);
      setLoading({
        status: "Error",
        message: "Error Loading Product Details",
      });
    }
  }

  // function goto_product_list() {
  //   if (productDetails && productDetails?.category_id) {
  //     history.push({
  //       pathname: `/gms/products/list/${productDetails.category_id}`,
  //     });
  //   } else {
  //     history.push({
  //       pathname: `/gms/products/list`,
  //     });
  //   }
  // }

  // const truncate = (input, stringLength) => {
  //   if (Utils.isUndefinedOrNull(input)) return "-";
  //   return input.length > stringLength
  //     ? `${input.substring(0, stringLength)}...`
  //     : input;
  // };

  // async function handle_delete_Product() {
  //   let res = await ServiceWrapper.doGet(
  //     api_base_url + "product/delete/" + productid,
  //     null,
  //     null,
  //     AuthManager.getGmsToken()
  //   );

  //   if (!res.errorfound) {
  //     appData.setProductDeleted(res.data.done);
  //     if (res.data.done) {
  //       appData.reset();
  //       window["bootbox"].dialog({
  //         title: "Product Deletion Success",
  //         message: "<p><strong>" + res.data.message + "</strong></p>",
  //         size: "medium",
  //         closeButton: false,
  //         centerVertical: true,
  //         buttons: {
  //           ok: {
  //             label: "OK, Thank you",
  //             className: "button-fill",
  //             callback: function () {
  //               goto_product_list();
  //             },
  //           },
  //         },
  //       });
  //     } else {
  //       window["bootbox"].dialog({
  //         title: "Product Deletion Failure",
  //         message:
  //           "<p>We are Sorry, We could not delete the selected product, Below is more information.</p><p><strong>" +
  //           res.data.message +
  //           "</strong></p>",
  //         size: "medium",
  //         closeButton: false,
  //         centerVertical: true,
  //         buttons: {
  //           ok: {
  //             label: "OK, I got it",
  //             className: "btn-info btn-sm",
  //             callback: function () {},
  //           },
  //         },
  //       });
  //     }
  //   } else {
  //     window["bootbox"].dialog({
  //       title: "Product Deletion Failure",
  //       message:
  //         "<p>We are Sorry, We could not delete the selected product, Below is more information.</p><p><strong>" +
  //         "We are facing a technical issue." +
  //         "</strong></p>",
  //       size: "medium",
  //       closeButton: false,
  //       centerVertical: true,
  //       buttons: {
  //         ok: {
  //           label: "OK, I got it",
  //           className: "btn-info btn-sm",
  //           callback: function () {},
  //         },
  //       },
  //     });
  //   }
  // }

  const [clipText, setClipText] = useState(null);

  function handle_clipbord(text) {
    navigator.clipboard.writeText(text).then(() => setClipText(text));
    setTimeout(() => {
      setClipText(null);
    }, 2000);
  }

  useEffect(() => {
    if(!productid) return

    load_Product_details_by_id();
    get_compactible_products(productid);
  }, [productid]);



  const get_compactible_products = async (productId) => {
    setLoadCompatible(true);
    let res = await ServiceWrapper.doGet(
      `${api_base_url}product/${productId}/compatibleproducts`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        setTimeout(() => {
          get_file_processing_status(res.data.jobid);
        }, 2000);
      } else {
        toast.error(res.data.message);
      }
    } else {
      toast.error("Error Loading Compatible Products");
    }
  };

  async function get_file_processing_status(jobid) {
    let ret = await ServiceWrapper.doGet(
      api_base_url + "job/status/" + jobid,
      null,
      null,
      AuthManager.getGmsToken(),
      true
    );

    if (!ret.errorfound) {
      if (ret.data.processing) {
        setTimeout(() => {
          get_file_processing_status(jobid);
        }, 2000);
      } else {
        setCompatibleProduct([])
        if (ret.data.error) {
          toast.error(ret.data.status);
        }
        if (ret.data.data) {
          setCompatibleProduct(ret.data.data);
          setLoadCompatible(false);
        }
      }
    } else {
      toast.error("An Error occured");
      // setShowCompatible(false);
      setCompatibleProduct([])
    }
  }

  const handleCompatibleProductsRefresh= (e) => {
    e.preventDefault()
    get_compactible_products(productid)
  }

  const staticHeadersForCompatibleProducts = [{name: "Name/Id", column: "name", options: { 
      width: "400px", 
      sticky: [true]
    }}
  ]

  return (
    <React.Fragment>

      {!showBuilder && Loading.status === "Loading" && <ProductViewSkeleton/>}

      {showBuilder ? <div>
      <ProductViewHeader productName={productDetails?.name ?? "---"} productid = {productid} categoryid = {productDetails?.category_id}/>

      <div className="tw-rounded tw-my-3 tw-flex tw-flex-grow tw-flex-wrap tw-box-border tw-border-[1px] tw-border-solid tw-border-[#E2E3E4]">
        <div className="tw-w-[16%] tw-p-2">
          <div className="tw-rounded  tw-w-[196px] tw-h-[196px] tw-bg-[#F7F7F7] tw-flex-shrink-0 tw-border-[#F2F2F2]">
            <img className="tw-p-2.5 tw-w-[196px] tw-h-[196px]" src={productImage? productImage : placeHolderImage} alt="Product" loading="lazy" />
          </div>
          <div className="tw-flex tw-w-48 tw-overflow-x-auto">
            {productImages && productImages?.length > 0 ? productImages?.map((imageUrl, index) => (
              <div key={index + imageUrl} className="tw-rounded tw-mt-1 tw-w-[35px] tw-h-[35px] tw-bg-[#F7F7F7] tw-flex-shrink-0 tw-border-[#F2F2F2] tw-mx-0.5" onClick={() => {setProductImage(imageUrl);}}>
                <img className="tw-w-[35px] tw-h-[35px]" src={imageUrl ? imageUrl : placeHolderImage} alt="" onError={({currentTarget}) => {
                  currentTarget.onerror = null;
                  currentTarget.src = placeHolderImage;
                }} loading="lazy"/>
              </div>
            )) : null}
          </div>
        </div>
        <div className="tw-w-[82%] tw-flex-wrap tw-mt-2 tw-ml-4">
          <h2 className="tw-text-xl tw-font-semibold">{productDetails?.name?.toString() ?? "---"}</h2>
          <h4 className="tw-text-sm tw-font-normal tw-mt-2.5">{productDetails?.description ?? "---"}</h4>          
          <p className="tw-small tw-mt-2 tw-mb-0 tw-ps-0">
            <span className="tw-text-xs tw-text-black "> 
              UID:{" "}
              <label className="tw-text-[#5c5f62]">{productDetails?.id ?? "---"}</label>
            </span>
            <i className={`${clipText === null ? "far" : "fas"} tw-ml-1 fa-clipboard tw-text-[0.95rem] tw-cursor-pointer tw-text-blue-500`}  onClick={() => handle_clipbord(productDetails.id)} />
            <label className="tw-text-xs tw-ml-1 tw-text-[#488328]">{clipText === null ? "" : "UID Copied"}</label>
          </p>
          <p className="small tw-mt-2 tw-mb-0 tw-ps-0">
            <span className="tw-text-xs"> 
              Model:{" "}
              <label className=" tw-text-[#5c5f62]">{productDetails?.model_number ?? "---"}</label>
            </span>    
          </p>
          <Attributes attr_value={productDetails?.attr_vals} />
          <MoreDetails 
            min_ad_price={productDetails?.min_ad_price?.toString() ?? "---"}
            upc={productDetails?.upc?.toString() ?? "---"}
            normalized_min_ad_price={productDetails?.normalized_min_ad_price?.toString() ??"---"}
            image_flag={productDetails?.image_flag ?? false}
            long_description={productDetails?.long_description ?? false}
            />
        </div>
      </div>

      <div className="tw-justify-between tw-flex tw-text-center tw-items-center tw-gap-2 tw-rounded tw-bg-white tw-box-border tw-w-auto tw-h-12 tw-border-[1px] tw-border-solid tw-border-gainsboro-200 tw-p-2.5">
        <div className="tw-flex tw-items-center tw-gap-2">
          <label className="tw-text-[16px] tw-font-semibold">Compatible products</label>
          <OverlayIcon message="This section displays products that work seamlessly with the current item based on established compatibility rules and specifications."/ >
        </div>
        <button onClick={handleCompatibleProductsRefresh} className="tw-p-0 tw-text-blue-500 tw-m-0 !tw-ma-w-min">
          <RefreshIcon/>
        </button>
      </div>
      {
        loadCompatible &&
        <div>
            <SkeletonElement type={"title"} />
            <SkeletonElement type={"title"} />
            <SkeletonElement type={"title"} />
            <SkeletonElement type={"title"} />
            <SkeletonElement type={"title"} />
        </div>
      }
      <div className="tw-pb-5">
        {
          !loadCompatible &&
          compatibleProduct?.categories &&
          compatibleProduct.categories.length > 0 &&
          compatibleProduct.categories.map((category, index) => (
            <div 
            key={index}
            >
                <AccordionLayout>
                    {(provided) => {
                    const attrs = Utils.generateHeadersFromArray(category?.columns ?? [])
                      
                    return (
                    <>
                          <div className={`tw-font-semibold tw-border tw-px-2`}>
                            <AccordionHeader {...provided.getHeaderProps()}>
                                    <p>{category.category_name}</p>
                            </AccordionHeader>
                          </div>

                        <AccordionBody {...provided.getBodyProps()}>
                          <div>
                            <DeltaTable
                              columns = {category?.columns ? [...staticHeadersForCompatibleProducts ,...attrs] : null}
                              // loading = {loading && isInitialLoading.current}
                              data = {category?.products}
                              options={{
                                disableSort: true,
                                disableHeaderControls: true,
                                disableRowOptions: true,
                                striped: true
                              }}
                              />
                          </div>
                        </AccordionBody>
                    </>
                    )}}
                </AccordionLayout>
            </div>

          ))
        }
      </div>
      </div> : <div>{showBuilder ? <span>No Products found</span>: null}</div>}
    </React.Fragment>
  );
};
export default ProductView;